import { useState } from 'react'
import { useAuth } from '@/hooks/useAuth'
import { BackendAuthService } from '../services/backendAuth'
import Logo from '@/components/Logo'

export default function Login() {
  const [isLoading, setIsLoading] = useState(false)
  const { error } = useAuth()

  const handleSSOLogin = async () => {
    setIsLoading(true)
    
    try {
      await BackendAuthService.loginWithSSO()
    } catch (error) {
      console.error('SSO login failed:', error)
      // Error will be handled by the auth hook or redirect
    } finally {
      setIsLoading(false)
    }
  }

  const isBackendConfigured = BackendAuthService.isConfigured()

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="card p-8 w-full max-w-md">
        <div className="flex justify-center mb-8">
          <Logo showStatus={false} className="text-2xl" />
        </div>
        
        {error && (
          <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded mb-4">
            {error}
          </div>
        )}

        {!isBackendConfigured && (
          <div className="bg-yellow-50 border border-yellow-200 text-yellow-700 px-4 py-3 rounded mb-4">
            <p className="font-medium">Backend SSO not configured</p>
            <p className="text-sm mt-1">
              Please set up your backend OIDC environment variables in the server <code>.env</code> file:
            </p>
            <ul className="text-sm mt-2 list-disc list-inside">
              <li>OIDC_CLIENT_ID</li>
              <li>OIDC_CLIENT_SECRET</li>
              <li>OIDC_TENANT_ID</li>
              <li>OIDC_AUTHORITY</li>
              <li>OIDC_REDIRECT_URI</li>
              <li>OIDC_SCOPE</li>
              <li>OIDC_FRONTEND_URL</li>
            </ul>
          </div>
        )}

        <div className="space-y-4">
          <button
            onClick={handleSSOLogin}
            disabled={isLoading || !isBackendConfigured}
            className="w-full flex items-center justify-center px-4 py-3 border border-gray-200/50 rounded-md shadow-sm bg-white text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <svg className="w-5 h-5 mr-3" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V6.3l7-3.11v8.8z"/>
            </svg>
            {isLoading ? 'Signing in...' : 'Sign in with SSO'}
          </button>
        </div>
      </div>
    </div>
  )
} 